<template>
  <button
    type="button"
    class="reader-bgm-control"
    :class="{ 'is-muted': muted }"
    :aria-label="
      disabled
        ? 'Background music is loading'
        : playing
          ? 'Pause background music'
          : 'Play background music'
    "
    :aria-pressed="playing"
    :aria-busy="disabled"
    :disabled="disabled"
    :title="disabled ? '背景音乐加载中' : playing ? '暂停背景音乐' : '播放背景音乐'"
    @pointerdown.stop
    @pointerup.stop
    @click="emit('toggle')"
  >
    <img
      class="reader-bgm-control__icon reader-bgm-control__icon--desktop"
      :src="playing ? desktopPlayingIcon : desktopPausedIcon"
      alt=""
      aria-hidden="true"
      draggable="false"
    />
    <img
      class="reader-bgm-control__icon reader-bgm-control__icon--mobile"
      :src="playing ? mobilePlayingIcon : mobilePausedIcon"
      alt=""
      aria-hidden="true"
      draggable="false"
    />
  </button>
</template>

<script setup lang="ts">
  import desktopPausedIcon from '@/assets/icons/svg/book/bgm-desktop-paused.svg?url';
  import desktopPlayingIcon from '@/assets/icons/svg/book/bgm-desktop-playing.svg?url';
  import mobilePausedIcon from '@/assets/icons/svg/book/bgm-mobile-paused.svg?url';
  import mobilePlayingIcon from '@/assets/icons/svg/book/bgm-mobile-playing.svg?url';

  defineProps<{
    playing: boolean;
    muted: boolean;
    disabled: boolean;
  }>();

  const emit = defineEmits<{
    toggle: [];
  }>();
</script>

<style scoped>
  .reader-bgm-control {
    --reader-bgm-control-size: clamp(32px, 8vmin, 40px);

    position: absolute;
    top: max(16px, env(safe-area-inset-top));
    right: max(16px, env(safe-area-inset-right));
    z-index: 30;
    width: var(--reader-bgm-control-size);
    height: var(--reader-bgm-control-size);
    display: block;
    padding: 0;
    background: transparent;
    border: 0;
    border-radius: 50%;
    cursor: pointer;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
    transition:
      transform 180ms ease,
      opacity 180ms ease;
  }

  .reader-bgm-control:not(:disabled):active {
    transform: scale(0.94);
  }

  .reader-bgm-control:focus-visible {
    outline: 2px solid #160211;
    outline-offset: 3px;
  }

  .reader-bgm-control.is-muted {
    opacity: 0.68;
  }

  .reader-bgm-control:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }

  .reader-bgm-control__icon {
    position: absolute;
    display: block;
    pointer-events: none;
  }

  .reader-bgm-control__icon--desktop {
    top: -12.5%;
    left: -15%;
    width: 130%;
    height: 130%;
  }

  .reader-bgm-control__icon--mobile {
    display: none;
  }

  @media (max-width: 720px) {
    .reader-bgm-control {
      top: max(12px, env(safe-area-inset-top));
      right: max(12px, env(safe-area-inset-right));
    }

    .reader-bgm-control__icon--desktop {
      display: none;
    }

    .reader-bgm-control__icon--mobile {
      inset: 0;
      width: 100%;
      height: 100%;
      display: block;
    }

    .reader-bgm-control:focus-visible {
      outline-color: #fff;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .reader-bgm-control {
      transition-duration: 0.01ms;
    }
  }
</style>
